<template>
    <AppMainSearchCard :tituloTela="tituloTela" :isLoading="isLoadingPrincipiosAtivos"
        @add="$router.push({ path: '/principioAtivo' })">

        <v-layout wrap row justify-center>
            <v-flex class="item" xs11 md11 lg11 pb-2>
                <v-text-field v-model="search" append-icon="fas fa-search" label="Pesquise por Identificador, Nome ou Descrição" 
                single-line hide-details outlined clearable ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3>
            <v-flex class="item" sm12 xs12 md12 lg12>
                <v-data-table :headers="headers" :search="search" @click:row="editItem"
                    no-results-text="Nenhum registro encontrado" :loading="isLoadingPrincipiosAtivos"
                    :must-sort="true" :items="principiosAtivos" color="secondary"
                    loading-text="Carregando registros...aguarde">
                </v-data-table>
            </v-flex>
        </v-layout>
    </AppMainSearchCard>
</template>

<script>
import AppMainSearchCard from '@/components/layout/AppMainSearchCard.vue'

export default {
    components: {
        AppMainSearchCard,
    },
    data: () => ({
        rowsPerPageItems: [5, 10, 15],
        pagination: {'sortBy': 'idPrincipioAtivo', 'descending': true, 'rowsPerPage': 5},
        tituloTela: 'Pesquisa de Princípios Ativos',
        registroSelected: '',
        headers: [            
            { text: 'Identificador', value: 'idPrincipioAtivo' },
            { text: 'Nome', value: 'nmPrincipioAtivo' },
            { text: 'Código na empresa', value: 'cdItem' },
            { text: 'Descrição', value: 'dsPrincipioAtivo' },
        ],
        principiosAtivos: [],
        isLoadingPrincipiosAtivos: false,
        isErrorPrincipioAtivo: false,
        query: {},
        search: '',
    }),
    methods: {
        initViewFromRoute(route) {
            this.query = Object.assign({}, route.query)
            this.searchItem()
        },
        editItem (value) {
            this.$router.push({ name: 'principioAtivo', params: { id : value.idPrincipioAtivo } })
        },
        searchItem() {
            var search = Object.assign({}, this.query)

            this.isLoadingPrincipiosAtivos = true

            this.$axios.get('principio-ativo/', { params: search })
            .then((response) => {
                if (response.data[0].data != null)
                    this.principiosAtivos = response.data[0].data
            })
            .catch((error) => {
                this.isErrorPrincipioAtivo = true
                this.$store.commit("setSnack", { type: "error", msg: error })
            })
            .finally(() => {
                this.isLoadingPrincipiosAtivos = false
            })
        },
        routeUpdate() {
            this.$router.push({ path : 'principioAtivoSearch', query: this.query })
        },
    },
    mounted () {
        this.initViewFromRoute(this.$route)
    },
    watch: {
        options: {
            handler () {
                this.searchItem()
            },
            deep: true
        }
    },
    beforeRouteUpdate(to, from, next){
        this.initViewFromRoute(to)
        next()
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
